export const TIMEZONES = [
  {
    label: 'Pacific Time',
    value: 'US/Pacific',
  },
  {
    label: 'Mountain Time',
    value: 'US/Mountain',
  },
  {
    label: 'Central Time',
    value: 'US/Central',
  },
  {
    label: 'Eastern Time',
    value: 'US/Eastern',
  },
  {
    label: 'Arizona Time - MST',
    value: 'America/Phoenix',
  },
  {
    label: 'Alaskan Time',
    value: 'America/Anchorage',
  },
  {
    label: 'Hawaiian Time',
    value: 'US/Hawaii',
  },
];
